// extracted by mini-css-extract-plugin
module.exports = {"search":"table-search_search_QP2RL","itemWrap":"table-search_itemWrap_2tU-v","item":"table-search_item_2Lq99","btn":"table-search_btn_zptz1"};